<script setup lang="ts">
import Button from "../components/form/Button.vue";

import { useRouter } from "../hooks";
const router = useRouter();

function gotoShape() {
  router.push("/shape");
}

function gotoShowcase() {
  router.push("/cs");
}

function gotoXGLot() {
  router.push("/lot?n=739");
}

function gotoRxmarbles() {
  router.push("/rx");
}

function gotoList() {
  router.push("/list");
}
</script>
<template>
  <div>
    <div class="gap">
      <Button @throttled-click="gotoShape">Shape</Button>
    </div>
    <div class="gap">
      <Button @throttled-click="gotoShowcase">Component ShowCase</Button>
    </div>
    <div class="gap">
      <Button @throttled-click="gotoXGLot">XG lot</Button>
    </div>
    <div class="gap">
      <Button @throttled-click="gotoRxmarbles">Rx Marbles</Button>
    </div>
    <div class="gap">
      <Button @throttled-click="gotoList">List Demo</Button>
    </div>
  </div>
</template>

<style scoped>
.gap {
  padding: 10px;
}
</style>
